type Props =  {
  children: React.ReactNode;
  className?: string;
}

const Card = ({ children, className }: Props) => {
  return (
    <div className={`bg-white rounded-md overflow-hidden shadow-full p-8 ${className}`}>
      {children}
    </div>
  );
};

export default Card;